import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TourStep } from './../../models/tour-step.model';

@Component({
  selector: 'lib-tour-tooltip',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './tour-tooltip.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tour-tooltip.component.scss',
})
export class TourTooltipComponent {
  private translate = inject(TranslateService);
  @Input({ required: true }) step!: TourStep;
  @Input() isRtl = true;
  @Input() style: Record<string, string> = {};
  @Output() nextClicked = new EventEmitter<void>();
  @Output() previousClicked = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();
  @Input({ required: true }) total!: number;
  @Input({ required: true }) currentStepIndex!: number;
  onNext(): void {
    this.nextClicked.emit();
  }

  onClose(): void {
    this.closed.emit();
  }

  onPrevious(): void {
    this.previousClicked.emit();
  }

  formatStep(value: number): string {
    return new Intl.NumberFormat(this.translate.currentLang || 'en').format(value);
  }
}
